class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    // On the /cart page itself, the icon should just reload /cart (let the
    // <a href> navigate) instead of opening the drawer over the same content.
    if (document.querySelector('cart-items')) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // Idempotent scroll-lock: open() can be called twice in quick succession
    // (e.g. CartHandler.add opens it and a caller chains its own open before
    // the async 'active' class lands). With the body already fixed, scrollY
    // reads 0 — re-saving it would jump the page to the top and close() would
    // restore scroll to 0. Only lock once.
    if (document.body.style.position !== 'fixed') {
      this._savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this._savedScrollY}px`;
      document.body.style.width = '100%';
      document.body.classList.add('overflow-hidden');
    }

    const gorgiasBtn = document.querySelector('#gorgias-chat-container');
    if (gorgiasBtn) gorgiasBtn.style.display = 'none';
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, this._savedScrollY || 0);

    const gorgiasBtn = document.querySelector('#gorgias-chat-container');
    if (gorgiasBtn) gorgiasBtn.style.display = '';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    // Parse the incoming cart-drawer section HTML
    var html = parsedState.sections['cart-drawer'];
    if (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');

      // Update cart items only
      var itemsSource = parsed.querySelector('cart-drawer-items');
      var itemsTarget = document.querySelector('cart-drawer-items');
      if (itemsSource && itemsTarget) {
        itemsTarget.innerHTML = itemsSource.innerHTML;
        if (typeof window.loadDrawerRatings === 'function') window.loadDrawerRatings();
      }

      // Update checkout section (total, button) without touching recommendations
      var checkoutSource = parsed.querySelector('.leh-cd-checkout');
      var checkoutTarget = document.querySelector('.leh-cd-checkout');
      if (checkoutSource && checkoutTarget) checkoutTarget.innerHTML = checkoutSource.innerHTML;
    }

    // Update cart icon bubble
    var bubbleHtml = parsedState.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      var bubbleParsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      var bubbleSource = bubbleParsed.querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleSource && bubble) bubble.innerHTML = bubbleSource.innerHTML;
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
